module.exports = __webpack_public_path__ + "img/header.500d2281.jpg";